var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.nota_credito.sale)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.show_sale.apply(null, arguments)}}},[_vm._v(" Venta N° "+_vm._s(_vm.nota_credito.sale.num)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }